import type { MapMargin } from '../model/types';
import type { YMapControlPosition, YMapZoomRounding } from '../model/ymaps';

export const YANDEX_MAPS_SRC = 'https://api-maps.yandex.ru/v3/?apikey=fd21f65c-506d-45d8-9cfe-18c5ad8d4173&lang=ru_RU';

export const MAP_COPYRIGHTS_POSITION: YMapControlPosition = 'top right';
export const MAP_DISTRIBUTION_POSITION: YMapControlPosition = 'top left';

export const HOTELS_MAP_SOURCE_ID = 'hotels-map-source';
export const HOTELS_MAP_LAYER_Z_INDEX = 1800;

export const CLUSTER_GRID_SIZE_PX = 64;
export const CLUSTER_MIN_SIZE = 2;
export const CLUSTER_MARGIN_PX = 10;

export const MAP_MIN_ZOOM = 2;
export const MAP_MAX_ZOOM = 20;
export const MAP_ZOOM_ROUNDING: YMapZoomRounding = 'snap';

export const SINGLE_HOTEL_ZOOM = 14;
export const FIRST_FIT_MAX_ZOOM = 15;

export const DEGENERATE_BOUNDS_EPS = 1e-7;

export const FIRST_FLY_DURATION_MS = 600;
export const FIRST_FLY_ZOOM_BACKOFF = 1;
export const CLUSTER_FLY_DURATION_MS = 400;
export const SELECT_FLY_DURATION_MS = 300;

export const CAMERA_THROTTLE_MS = 200;
export const CHIP_TAP_TOLERANCE_PX = 10;
export const CHIP_TAP_MAX_DURATION_MS = 500;
export const PENDING_TAP_TIMEOUT_MS = 450;
export const MARKER_HIDE_EXTENT_PX = 160;
export const PRODUCTS_DEBOUNCE_MS = 300;

export const MAP_MARGIN: MapMargin = [72, 68, 96, 68];
export const MAP_MARGIN_WITH_CARD: MapMargin = [72, 68, 356, 68];
export const MAP_CARD_GAP_PX = 32;

export const MARKER_Z_CLUSTER = 10;
export const MARKER_Z_PIN = 20;
export const MARKER_Z_SELECTED = 1000;
